export default __webpack_public_path__ + "static/media/sustentabilidade-banner-site.d2682bb4.png";